import styled from 'styled-components';
import { getColor } from '../../../../../utils';

export const Wrapper = styled.div`
  margin-bottom: 20px;
`;

export const ButtonsRow = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 12px;
`;

export const ButtonWrapper = styled.div`
  width: max-content;
  margin: 8px auto;
  padding: 8px 12px;
  border-radius: 3px;
  cursor: pointer;

  font-weight: ${props => (props.selected ? 600 : 400)};
  border: 1px solid ${props => (props.selected ? `#4A7F9E` : '#cccccc')};
  ${props =>
    props.selected && 'box-shadow: -3px 3px 5px 6px rgba(100, 100, 100, 0.2);'}
  ${props => props.selected && `color: #4A7F9E;`}

  transition: all 0.3s;

  &:hover {
    font-weight: 600;
    border-color: #aaaaaa;
  }

  & > div:nth-child(1) {
    height: 120px;
    width: 100px;
    border-radius: 2px;

    img {
      height: 100%;
      width: 100%;
      object-fit: contain;
    }
  }

  & > div:nth-child(2) {
    width: 100px;
    text-align: center;
    padding-top: 8px;
    font-size: 13px;
  }
`;
